import React, { useMemo, useRef, useEffect, useState } from 'react';
import { MainTextInput } from '.';
import { FieldI } from 'form-defs/form-def.interface';
import styled from 'styled-components/macro';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import Booking from 'store/models/bookings/Booking';
import { useDispatch } from 'react-redux';
import {
  Box,
  FormHelperText,
  FormLabel,
  Popover,
} from '@material-ui/core';
import BookingInfoPanel from './BookingInfoPanel';
import { bookingInfoActions } from 'store/actions';
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import loadingImg from 'assets/images/spinner.gif';
import {
  bookingIdToInfoResSelector,
  bookingInfoIsLoadingAtRowIndexMapSelector,
  showingBookingInfoIndexSelector,
} from 'store/selectors/booking-info.selector';
import { BookingInfo } from 'store/models/BookingInfo';

interface BookingNoInputProps {
  field?: FieldI;
  handleValueChanged?: (value: any, name?: string) => void;
  bookingM: Booking;
  handleOnBlur?: (value: any, name?: string) => void;
  verticalDir: 'top' | 'bottom';
  index: number;
  disabled?: boolean;
  handleOnFocus?: (value: any, name?: string) => void;
  showValAsTransparentOnBlur?: boolean;
  hideInfoIcon?: boolean;
}

const BookingNoInput: React.FC<BookingNoInputProps> = ({
  field,
  handleValueChanged,
  bookingM,
  handleOnBlur,
  verticalDir = 'top',
  index,
  disabled,
  handleOnFocus,
  showValAsTransparentOnBlur = false,
  hideInfoIcon = false,
}) => {
  useEffect(() => {
    console.debug(`rerender`);
  }, []);

  const dispatch = useDispatch();
  const showingIndex = useSelector(showingBookingInfoIndexSelector);
  const showBookingInfo = useMemo(() => index === showingIndex, [
    showingIndex,
    index,
  ]);
  const bookingIdToInfoRes = useSelector(bookingIdToInfoResSelector);
  const bookingInfoResObjSelector = useMemo(
    () =>
      createSelector(
        bookingIdToInfoResSelector,
        (data) =>
          (bookingM?.bookingNo &&
            data &&
            data[bookingM?.bookingNo]) ||
          {},
      ),
    [bookingM],
  );

  const bookingInfoResObj = useSelector(bookingInfoResObjSelector);

  const {
    // isLoading = false,
    bookingInfoRes,
  } = bookingInfoResObj;
  const bookingInfoM: undefined | BookingInfo = useMemo(
    () => bookingInfoRes && new BookingInfo(bookingInfoRes),
    [bookingInfoRes],
  );

  const fetchData = (bookingNo?: string) => {
    // check if empty and is right format first -> do not fetch if not correct format
    if (!bookingNo) bookingNo = bookingM?.bookingNo;
    const isBookingNo = bookingNo && Booking.isBookingNo(bookingNo);
    if (!isBookingNo) {
    } else {
      if (!bookingNo) return;

      if (!(bookingNo in bookingIdToInfoRes)) {
        dispatch(
          bookingInfoActions.getManyBookingInfo([bookingNo], [index]),
        );
      }
    }
  };

  const showingAnchorEl = useRef<any>(null);

  const handleToggleInfo = (e) => {
    console.debug(`click toggle info. current: `, showBookingInfo);
    if (showBookingInfo) {
      dispatch(bookingInfoActions.closeBookingInfo());
    } else {
      dispatch(bookingInfoActions.showBookingInfoAtIndex(index));
      fetchData();
    }
  };
  const handleCloseInfo = () => {
    dispatch(bookingInfoActions.closeBookingInfo());
  };

  const isLoadingAtRowIndexMap = useSelector(
    bookingInfoIsLoadingAtRowIndexMapSelector,
  );

  const indexToConsiderIsLoading = useMemo(
    () => (index === -1 ? 0 : index),
    [index],
  );

  const showIsLoading = useMemo(
    () =>
      isLoadingAtRowIndexMap &&
      isLoadingAtRowIndexMap[indexToConsiderIsLoading],
    [isLoadingAtRowIndexMap, indexToConsiderIsLoading],
  );

  useEffect(() => {
    console.debug(`showBookingInfo`, showBookingInfo);
  }, [showBookingInfo]);
  const [isSeeDetail, setIsSeeDetail] = useState(true);
  const renderToggleInfo = () => {
    if (showIsLoading) return <SLoading src={loadingImg} />;
    if (!bookingM) return null;
    const hasInfoPanel = bookingInfoM?.hasInfoPanel;
    const [
      status,
      statusText,
    ] = bookingM.getBookingStatusAndStatusText(bookingInfoM);
    const shouldShowStatusText = !hasInfoPanel ? isSeeDetail : true;
    const isOpenInfo = hasInfoPanel || isSeeDetail;
    return (
      <SIndicatorsContainer>
        <SIndicators
          className={`${status} ${isOpenInfo ? 'isOpen' : ''} `}
        >
          {shouldShowStatusText && <div>{statusText}</div>}
          <SInfoIcon
            fontSize="small"
            color="primary"
            onClick={(e) => {
              if (hasInfoPanel) handleToggleInfo(e);
              else setIsSeeDetail(!isSeeDetail);
            }}
          />
        </SIndicators>
      </SIndicatorsContainer>
    );
  };
  return (
    <SRoot>
      <SInputContainer>
        {/* note top left main booking no uses field.label but the multi booking doesn't */}
        {field?.label && (
          <Box
            marginBottom="0.5rem"
            display="flex"
            justifyContent="space-between"
          >
            <SFormLabel>{field?.label}</SFormLabel>
          </Box>
        )}
        <MainTextInput
          name={field?.name}
          // label={field?.label}
          disabled={disabled || field?.disabled}
          isMultiRow={field?.isMultiRow}
          value={bookingM?.bookingNo}
          labelOnLeft={field?.labelOnLeft}
          rows={field?.rows}
          handleAfterChange={(value) => {
            // if (handleValueChanged)
            //   handleValueChanged(value, field?.name);
            // if (showBookingInfo) fetchData(value);
            handleCloseInfo();
          }}
          handleOnBlur={(value) => {
            if (handleOnBlur) handleOnBlur(value, field?.name);
          }}
          handleOnFocus={(value) => {
            if (handleOnFocus) handleOnFocus(value, field?.name);
          }}
          // error={bookingM?.getErrorStatus()}
          // don't add autofocus, if so when edit the top the bottom will get edit
          showValAsTransparentOnBlur={showValAsTransparentOnBlur}
        />
        {!hideInfoIcon && (
          <SInforIconWrapper
            ref={showingAnchorEl}
            className={`${
              field?.name === 'bookingNo' ? 'labelOnLeft' : ''
            }`}
          >
            {renderToggleInfo()}
          </SInforIconWrapper>
        )}
        <Popover
          open={showBookingInfo && !showIsLoading}
          anchorEl={showingAnchorEl.current}
          onClose={handleCloseInfo}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <BookingInfoPanel
            isLoading={showIsLoading}
            bookingInfoM={bookingInfoM}
            bookingNoIsWrongFormat={
              bookingM && !bookingM.isBookingNoRightFormat()
            } // pass error
            index={index} // -1 means top left then 0 is the first of the bookings on the bottom
          />
        </Popover>
      </SInputContainer>
      <SFormHelperText error>
        {/* NOTE: not sure if should use static function in the class or not for this */}
        {/* {bookingM?.getErrorStatus()} */}
      </SFormHelperText>
    </SRoot>
  );
};

export default BookingNoInput;
const SIndicatorsContainer = styled.div`
  background-color: white;
`;

const SIndicators = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.palette.primary.main};
  & > svg {
    color: ${(props) => props.theme.palette.primary.main};
  }
  border-radius: 20px;
  height: 30px;
  padding: 0px 0px 0px 15px;
  &.found {
    padding: 0px 0px 0px 0px;
    & > svg {
      color: ${(props) => props.theme.palette.success.dark};
    }
  }
  &.isSplit {
    color: ${(props) => props.theme.palette.success.dark};
    & > svg {
      color: ${(props) => props.theme.palette.success.dark};
    }
  }
  &.notFound {
    color: ${(props) => props.theme.palette.error.main};
    & > svg {
      color: ${(props) => props.theme.palette.error.main};
    }
  }
  &.isCancelled {
    color: ${(props) => props.theme.palette.error.main};
    & > svg {
      color: ${(props) => props.theme.palette.error.main};
    }
  }
  &.isRequired {
    color: ${(props) => props.theme.palette.error.main};
    & > svg {
      color: ${(props) => props.theme.palette.error.main};
    }
  }
  &.isWrongFormat {
    color: ${(props) => props.theme.palette.error.main};
    & > svg {
      color: ${(props) => props.theme.palette.error.main};
    }
  }
  &.isDuplicated {
    color: ${(props) => props.theme.palette.error.main};
    & > svg {
      color: ${(props) => props.theme.palette.error.main};
    }
  }
  &.apiError {
    color: ${(props) => props.theme.palette.error.main};
    & > svg {
      color: ${(props) => props.theme.palette.error.main};
    }
  }
  &.isOpen {
    &.isSplit {
      background-color: ${(props) =>
        props.theme.palette.success.lightRGBA};
    }
    &.notFound {
      background-color: ${(props) =>
        props.theme.palette.error.lightRGBA};
    }
    &.isCancelled {
      background-color: ${(props) =>
        props.theme.palette.error.lightRGBA};
    }
    &.isRequired {
      background-color: ${(props) =>
        props.theme.palette.error.lightRGBA};
    }
    &.isWrongFormat {
      background-color: ${(props) =>
        props.theme.palette.error.lightRGBA};
    }
    &.isDuplicated {
      background-color: ${(props) =>
        props.theme.palette.error.lightRGBA};
    }
    &.apiError {
      background-color: ${(props) =>
        props.theme.palette.error.lightRGBA};
    }
  }
`;

const SInforIconWrapper = styled.div`
  position: absolute;
  right: 3px;
  bottom: 10px;
  &.labelOnLeft {
    bottom: 5px;
  }
`;
const SLoading = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 0.4rem;
  margin-bottom: 0.3rem;
  width: 20px;
`;

const SInputContainer = styled.div`
  position: relative;
  display: grid;
`;

const SRoot = styled.div`
  position: relative;
  display: grid;
`;

const SInfoIcon = styled(InfoIcon)`
  cursor: pointer;
  bottom: 0;
  right: 0;
  padding: 0.6rem;
  margin-right: 0.2rem;
  margin-bottom: 0.1rem;
`;

const SFormHelperText = styled(FormHelperText)`
  position: absolute;
  bottom: -1.2rem;
  left: 0.2rem;
`;
const SFormLabel = styled(FormLabel)`
  &.MuiFormLabel-root {
    color: ${(props) => props.theme.palette.text.primary};
  }
`;
